<template>
  <div class='inner'>
    <div v-for='item in collections' :key='item.id' class='item'>
      <!-- Les pastilles de comptage sont a l'interieur du span cliquable, comme dans
           Arbo.vue : cliquer un compteur deplie ou replie la ligne. -->
      <span class='name' @click='toggle(item.id)' v-bind:class='{ changed: item.modified }'>
        <b-icon v-bind:icon="'clipboard-list'" v-bind:class="'clipboard-list'" pack='fas' size='is-small' />
        {{ item.name }}
        <span v-if="!isCollectionMembersRead(item)" class="unread">
          *
        </span>
        <template v-if='item.documentsTotal > 0'>
          <span v-text='item.documentsTotal' class='tag is-rounded is-small' />
          <span v-if='item.documentsTotal - item.documentsReadCount > 0'
            v-text='item.documentsTotal - item.documentsReadCount' class='tag is-rounded is-primary' />
        </template>
      </span>
      <PortefeuilleArboDocs v-if='item.documents.length > 0 && expanded.indexOf(item.id) !== -1' :id='id' :level='level'
        :documents='item.documents' />
    </div>
  </div>
</template>

<script>
import PortefeuilleArboDocs from '@/components/Portefeuille/ArboDocs'

import MixinDocumentHelper from '@/mixins/DocumentHelper'

export default {
  mixins: [MixinDocumentHelper],
  components: {
    PortefeuilleArboDocs,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    collections: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      expanded: [],
    }
  },
  methods: {
    // `async` et `await` sur le dispatch : le try/catch doit encore etre en place quand la
    // promesse se regle. Rien ne suit le dispatch dans cette branche, donc l'attente ne
    // decale aucun traitement.
    async toggle (id) {
      const index = this.expanded.indexOf(id)
      if (index === -1) {
        this.expanded.push(id)
        const item = this.collections.find((i) => i.id === id)
        if (item && !item.details && item.documents.length > 0) {
          try {
            await this.$store.dispatch('inv/getCollectionDetails', {
              arboLevel: this.level,
              arboID: this.id,
              collectionID: item.id,
            })
          } catch (e) {
            console.error('getCollectionDetails:', e)
            this.apiError(e)
          }
        }
      } else {
        this.expanded.splice(index, 1)
      }
    },
    isCollectionMembersRead (col) {
      return col.documents.every(doc => this.isRead(doc.id))
    }
  },
}
</script>

<style lang='scss' scoped>
.inner {
  position: relative;
  min-height: 10px;
}

.item {
  font-size: 0.9em;
  padding: 0.2em 0 0.2em 0.5em;
}

// Le curseur et le survol portent sur le conteneur cliquable, non sur chacun de ses span,
// comme dans Arbo.vue. `cursor` etant herite, les enfants le recoivent ; en revanche la
// couleur de survol ne s'applique pas aux pastilles, qui definissent la leur — celle de
// is-primary est du blanc sur fond colore.
.name {
  cursor: pointer;

  &:hover {
    color: #ed9e1a;
  }
}

.changed {
  color: #35a0d0;
}

.files {
  padding-bottom: 1em;

  span {
    display: block;
    padding: 3px 0 3px 26px;
  }
}

.icon {
  margin-right: 0.15em;
}

.menu {
  position: absolute;
  padding: 0.2em 0.5em;
  background: #fff;
  border: 2px solid #ccc;
  z-index: 2;

  a {
    display: block;
    font-size: 0.75em;
    padding: 0.3em 0;
  }
}

span.unread {
  font-weight: bold;
  color: #ed9e1a;
}

// Meme regle que dans Arbo.vue, dont le style scoped ne s'applique pas ici. Le contexte
// vaut 0.9em de part et d'autre — porte par .name dans Arbo.vue, par .item ici — la taille
// rendue est donc identique.
span.tag {
  font-size: 0.6em;
  position: relative;
  top: -0.2em;
  margin-left: 0.5em;
}

.clipboard-list {
  color: #c28655;
}
</style>
